import { render } from "./inbox-unread-count.vue?vue&type=template&id=3ad8be7d"
import script from "./inbox-unread-count.vue?vue&type=script&lang=js"
export * from "./inbox-unread-count.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__